import { useCallback, useMemo } from 'react';
import get from 'lodash/get';
import copyMagicLog from 'common/components/CopyMagic/shared/copyMagicLog';
import { useConfigContext } from 'common/components/CopyMagic/contexts';
import { GENERATOR_TRACKING_HOOKS } from './constants';

/*
useGeneratorTrackingCallback
  Finds and calls a tracking hook based on the `generatorName` and `hookName`
*/

type Callback = (data?: object) => void; // eslint-disable-line no-unused-vars
type Hook = () => Callback;

const useGeneratorTrackingCallback = (hookName: string): Callback => {
  const { generatorName } = useConfigContext();

  const useNoop = useCallback(() => {
    copyMagicLog(
      `useGeneratorTrackingCallback n/a for generator: ${generatorName} hookName: ${hookName}`,
    );
  }, [generatorName, hookName]);

  const useTrackingHook: Hook = useMemo(
    () => get(GENERATOR_TRACKING_HOOKS, [generatorName, hookName], useNoop),
    [generatorName, hookName, useNoop],
  );

  return useTrackingHook();
};

export default useGeneratorTrackingCallback;
